/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react";
import { atom, useRecoilState } from "recoil";

import api, { riderId } from "../Api";

import Cs from "../../models/Cs";

export const CS_TYPE_USER = "USER";
export const CS_TYPE_CHAINLOGIS = "CHAINLOGIS";

const csAtom = atom({
  key: "cs",
  default: null,
});

const hasCsesByBookIdAtom = atom({
  key: "hasCsesByBookId",
  default: false,
});

const hasCsesByBookIdNonCheckedAtom = atom({
  key: "hasCsesByBookIdNonChecked",
  default: false,
});

const csesUserByBookIdAtom = atom({
  key: "csesUserByBookId",
  default: null,
});

const csesChainlogisByBookIdAtom = atom({
  key: "csesChainlogisByBookId",
  default: null,
});

export const useCsesStore = () => {
  const [cs, setCs] = useRecoilState(csAtom);
  const [hasCsesByBookId, setHasCsesByBookId] =
    useRecoilState(hasCsesByBookIdAtom);
  const [hasCsesByBookIdNonChecked, setHasCsesByBookIdNonChecked] =
    useRecoilState(hasCsesByBookIdNonCheckedAtom);
  const [csesUserByBookId, setCsesUserByBookId] =
    useRecoilState(csesUserByBookIdAtom);
  const [csesChainlogisByBookId, setCsesChainlogisByBookId] = useRecoilState(
    csesChainlogisByBookIdAtom,
  );

  const fetchById = useCallback(async () => {
    if (riderId) {
      // const response = await api.get(`/riders/${riderId}/allocated-deliveries`);

      setCs({});
    }
  }, [api.get, riderId]);

  /**
   * 배송건에 속한 CS 목록 조회
   */
  const fetchCsesById = useCallback(
    async ({ bookId, receiptDate }) => {
      const response = await api.get(`/deliveries/${bookId}/cses/all`);

      const csesUserByBookId = receiptDate
        ? response?.rows.filter(
            (e) => !e.userId && e.createdAt > receiptDate,
          ) || []
        : response?.rows.filter((e) => !e.userId) || [];
      const csesChainlogisByBookId = receiptDate
        ? response?.rows.filter(
            (e) => !!e.userId && e.createdAt > receiptDate,
          ) || []
        : response?.rows.filter((e) => !!e.userId) || [];

      setCsesUserByBookId(csesUserByBookId.map((d) => new Cs(d)));
      setCsesChainlogisByBookId(csesChainlogisByBookId.map((d) => new Cs(d)));
      setHasCsesByBookId(response?.rows.length > 0);
      setHasCsesByBookIdNonChecked(
        response?.rows.filter((e) => !e.checked).length > 0,
      );

      return response;
    },
    [api.get],
  );

  const state = {
    cs,
    hasCsesByBookId,
    hasCsesByBookIdNonChecked,
    csesUserByBookId,
    csesChainlogisByBookId,
  };

  return { state, fetchById, fetchCsesById };
};
